import React from 'react';
import axios from 'axios';
import Button from '@material-ui/core/Button';

const TriggerZoneButton = (props) => {
    const { zoneId } = props; // ZoneId should be passed as a prop to this component

    async function handleClick() {
        try {
            //confirm that the user wants to trigger the zone
            const confirm = window.confirm('Are you sure you want to trigger this zone?');

            if (!confirm) return;

            //second confirm that the user wants to trigger the zone
            const confirm2 = window.confirm('Are you really sure you want to trigger this zone?');

            if (!confirm2) return;

            const response = await axios.post('/api/zone-trigger', { zoneId });

            if (response.status === 200) {
                alert('Successfully triggered zone');
            } else {
                alert('Error triggering zone, try again later');
            }
        } catch (error) {
            console.error("Error triggering zone", error);
            alert('Error triggering zone, try again later');
        }
    }

    return (
        <Button
            variant="outlined" color="primary"
            onClick={handleClick}
        >
            Trigger Zone
        </Button>
    );
}

export default TriggerZoneButton
